var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_24860"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    x: 0.1,
    y: 0.4,
    style: {
      fill: "none"
    },
    width: 149.9,
    height: 149.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    style: {
      fill: "#DCEEFE"
    },
    d: "M123.2,52.6c-20.3,4.7-15.4-46.7-48-36.2C66,19.3,41.3,1.8,34.4,29.9 c-1.6,6.7-7.5,7.4-15.9,11.6c-8.5,4.2-10.6,15.7-9.1,26C6.6,80.7,17.5,90.2,26,88.2c20.3-4.7,15.4,46.7,48,36.2 c9.2-2.9,33.9,14.6,40.8-13.5c1.6-6.7,7.5-7.4,15.9-11.6c8.5-4.2,10.6-15.7,9.1-25.9C142.7,60.1,131.8,50.6,123.2,52.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0564B7"
    },
    d: "M97.4,76.4c-0.2-0.3-0.4-0.7-0.6-1 c-0.2-0.4-0.4-0.9-0.5-1.4c-0.1-0.6-0.3-1.3-0.4-1.9c-0.1-0.5-0.4-1-0.7-1.4c-0.5-0.6-0.9-1.2-1.4-1.8c-0.1-0.1-0.1-0.3-0.2-0.4 c0-0.3,0-0.6-0.1-0.9c-0.1-0.8-0.2-1.6-0.2-2.4c-0.1-1.3-0.2-2.7-0.2-4.1c-0.1-1.1-0.1-2.2-0.2-3.3c-0.1-1.7-0.5-3.4-1.2-5 c0-0.1-0.1-0.3,0-0.4c0-0.3,0.1-0.6,0.1-1c0.1-1,0-2-0.1-3c-0.3-2.2-0.9-4.3-1.6-6.4C90,41.9,90,41.7,90,41.5 c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.7,0.1-1c0.1-0.8,0.1-1.5-0.1-2.3c-0.3-1.3-0.8-2.6-1.5-3.8c-0.6-1-1.5-1.9-2.6-2.5 c-0.5-0.3-1-0.5-1.5-0.7c-0.6-0.1-1.1-0.2-1.6-0.4c-0.2-0.1-0.5-0.2-0.7-0.3c-0.9-0.5-1.8-1-2.8-1.5c-0.7-0.4-1.4-0.6-2.1-1 C77,27.2,77,27.2,77,26.9c-0.1-1,0-2,0.2-3c0,0,0,0,0,0s0,0,0,0c0.2-0.3,0.3-0.6,0.4-1c0-0.3,0.1-0.5,0.1-0.8 c0.3,0.1,0.5,0,0.7-0.2c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.4-0.5c0.2-0.4,0.4-0.8,0.3-1.2c0-0.4,0.1-1.3-0.4-1.4 c-0.2,0-0.3,0.1-0.4,0.2v0c0-0.4,0.1-0.8,0.1-1.1c0.3-1.3,0.2-2.6-0.5-3.8c-0.8-1.5-2.3-2.6-4-2.9c-4.2-0.8-7.8,2.3-7.3,6.6 c0.1,0.4,0.2,0.8,0.3,1.1c0,0,0,0.1,0.1,0.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.5,0.1-0.4,1-0.4,1.4c0,0.4,0.1,0.9,0.3,1.2 c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.2,0.2,0.6,0.2,0.9,0.1c0,0.1,0,0.3,0,0.4c0,0.5,0.2,0.9,0.4,1.3 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.7,0.2,2.2,0.2,2.5c0,0.4-0.1,0.5-0.5,0.7c0,0-0.1,0-0.1,0c-0.6,0.3-1.3,0.6-1.9,0.9 c-0.8,0.5-1.7,0.9-2.5,1.4c-0.4,0.3-0.9,0.4-1.3,0.5c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.8,0.2-1.2,0.4c-1.3,0.7-2.5,1.7-3.2,3 c-1.1,1.8-1.6,3.9-1.4,6c0,0.1,0,0.1,0,0.2c0,0.4,0,0.7,0.1,1.1c0.1,0.4,0.1,0.7,0,1.1C56,44,55.5,46,55.1,47.9 c-0.3,1.5-0.3,3.1-0.1,4.7c0,0.2,0,0.4-0.1,0.5c-0.3,0.8-0.6,1.7-0.8,2.6c-0.3,1.7-0.5,3.4-0.6,5.2c0,0.8-0.1,1.6-0.1,2.4 c-0.1,1-0.2,2-0.2,2.9c-0.1,0.7-0.2,1.3-0.2,1.9c0,0.5-0.2,1-0.5,1.3c-0.5,0.5-0.8,1.1-1.3,1.6c-0.2,0.2-0.3,0.4-0.4,0.7 c-0.2,0.8-0.4,1.5-0.6,2.3c-0.1,0.4-0.2,0.8-0.4,1.2c-0.2,0.4-0.5,0.8-0.7,1.3c-0.2,0.2-0.1,0.4,0.2,0.5c0.4,0.1,0.9,0.1,1.2-0.2 c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.2l0.1,0c0,0.1,0,0.2,0,0.3c-0.1,0.8-0.2,1.6-0.3,2.3c-0.1,0.7-0.1,1.3-0.2,2 c0,0.3,0,0.5,0,0.8c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2,0,0.2-0.1c0.4-0.4,0.7-0.9,0.8-1.4c0.2-1,0.5-2,0.7-2.9c0-0.1,0-0.1,0.1-0.2 c0,0,0.1,0.1,0.1,0.2c0,0.2,0,0.5,0,0.7c0,0.6-0.1,1.2-0.1,1.8c0,0.8,0,1.5,0.1,2.2c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.3,0.1,0.4-0.1l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.8,0.4-1.6,0.5-2.5c0.1-0.5,0.1-0.9,0.2-1.4c0,0.1,0,0.2,0,0.2 c0,0.8,0,1.7,0,2.5c0,0.3,0,0.6,0.1,0.9c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.2c0-0.1,0-0.2,0.1-0.2 c0.1-0.4,0.1-0.8,0.2-1.3c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.3,0.1,0.3,0.5,0.3c0,0,0.1,0,0.1,0c0-0.2,0.1-0.3,0.1-0.4 c0-0.4,0-0.8,0-1.2c-0.1-1,0-2,0.1-2.9c0.1-0.6,0.2-1.2,0.2-1.7c0-0.2,0-0.4,0-0.6c0.1-0.8,0.1-1.5,0.1-2.3 c0-0.7-0.1-1.4-0.3-2.1c-0.1-0.2-0.1-0.5,0-0.7c0.3-0.9,0.7-1.8,1-2.7c0.7-2.1,1.3-4.2,2-6.4c0.4-1.3,0.6-2.7,0.6-4.1 c0-0.4,0-0.7,0-1.1c0-0.4,0-0.9,0-1.3c0-0.3,0-0.5,0.2-0.7c0.4-0.7,0.7-1.4,1-2.2c0.3-0.8,0.5-1.6,0.7-2.4c0-0.1,0.1-0.2,0.1-0.3 c0.1,0.3,0.3,0.6,0.4,0.9c0,0.1,0,0.1,0,0.2c0.1,1.1,0.2,2.3,0.3,3.4c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7,0,1.4,0,2.2 c0,0.9,0,1.8,0.1,2.7c0,0.3,0.1,0.7,0.2,1c0.1,0.2,0.1,0.5,0,0.8c-0.1,0.3-0.2,0.5-0.2,0.8c-0.3,1.1-0.4,2.3-0.2,3.4 c0,0.1,0,0.2,0,0.4c-0.1,0.7-0.3,1.4-0.4,2.1c-0.4,2.2-0.8,4.5-1.2,6.8c-0.2,1.1-0.3,2.2-0.4,3.4c-0.2,1.5-0.2,3.1-0.2,4.6 c0,0.9,0.1,1.9,0.1,2.8c0,0.5,0.2,1,0.2,1.5c0.2,1.5,0.4,2.9,0.5,4.4c0.1,1,0.1,2,0,2.9c-0.2,1.3-0.3,2.7-0.3,4.1 c0,0.3,0,0.6-0.1,0.8c-0.4,1.2-0.7,2.5-0.8,3.7c-0.4,4.8-0.4,9.6,0,14.3c0,0,0.2,3.7,0.2,4.6c0,1-0.2,2-0.7,2.9 c-1.1,2.3-3,4.4-4.6,6.4c-0.4,0.5-0.8,0.9-1.4,1.2c-0.3,0.2-0.5,0.5-0.7,0.8c-0.1,0.2-0.2,0.4-0.1,0.6c-0.2,0.7,0.2,0.8,0.2,0.8 c0.1,0.3,0.5,0.5,0.8,0.4c0.7,0.7,1.1,0.1,1.1,0.1c0.8,0.9,1.6,0.7,2.6-0.1s0.9-0.5,1.4-0.7c2.2-0.9,2.3-3,4.2-4.1 c2.1-1.2,2.7-2.5,2.4-3.3c-0.2-0.7-0.3-1.3-0.4-2c0.2-0.3,0.3-0.7,0.2-1.1c-0.4-1.5-0.2-1.7,0.1-4.8c0.5-2.8,0.8-6.1,2.2-8.6 c0.5-0.9,0.8-1.9,0.9-2.9c0.1-0.8,0.1-1.6,0.1-2.3c0-1-0.1-1.9-0.3-2.9c-0.1-0.7-0.2-1.4-0.3-2.1c0-0.2,0-0.3,0.1-0.4 c0.2-0.4,0.4-0.8,0.6-1.3c0.2-0.9,0.4-1.8,0.4-2.7c0-0.5,0-1,0.1-1.5c0-0.4,0.1-0.8,0.2-1.1c0.8-1.5,1.4-3.1,1.9-4.8 c0.5-1.6,0.8-3.2,1.2-4.8c0.3-1.4,0.6-2.7,0.9-4.1c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.2,0.8,0.3,1.2c0.3,1.4,0.7,2.7,1,4.1 c0.6,2.8,1.6,5.4,2.9,7.9h0c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.1,0,0.1c0.1,0.9,0.2,1.5,0.2,1.8l0,0c0,0.1,0,0.3,0,0.4 c0,0.9,0.1,1.8,0.4,2.7c0.1,0.4,0.3,0.9,0.6,1.3c0.1,0.1,0.3,0.6-0.1,2.8c-0.1,0.9-0.2,1.9-0.2,2.9c0,0.8,0,1.6,0.1,2.3 c0.2,1,0.5,2,1,2.9c1.4,2.4,1.7,5.6,2.2,8.4c0.4,3.1,0.5,3.2,0.2,4.7c-0.1,0.4,0,0.9,0.3,1.2c0,0-0.1,0.8-0.2,1.6 c-0.2,1.5,0,2.4,2.2,3.6c1.9,1.1,2,3.3,4.3,4.1c0.5,0.2,0.5-0.1,1.4,0.8c0.9,0.9,1.7,0.9,2.5-0.1c0,0,0.5,0.5,1.1-0.1 c0.3,0.1,0.7-0.1,0.8-0.4c0,0,0.5-0.2,0.2-0.7c0,0,0.4-0.2-0.5-1.2c-0.2-0.3-0.7-0.2-1.5-1.3c-1.3-1.6-2.5-3.3-3.7-5 c-0.6-0.7-1.1-1.5-1.4-2.3c-0.2-0.6-0.3-1.2-0.4-1.8c0-2.2,0.1-4.4,0.1-6.6c0-4.2,0-8.3-0.4-12.5c-0.2-1.2-0.5-2.4-0.8-3.5 c-0.1-0.3-0.2-0.7-0.3-1.1c0.1-1.4,0-2.7-0.3-4.1c-0.2-1-0.2-2-0.2-3c0-0.5,0.1-0.9,0.1-1.4c0.1-0.5,0.1-1.1,0.2-1.6 c0.1-0.6,0.2-1.3,0.2-1.9c0.1-0.6,0.2-1.2,0.2-1.8c0-0.9,0-1.9,0-2.8c0-1.6-0.1-3.1-0.3-4.7c-0.2-1.3-0.4-2.6-0.6-3.9 c-0.2-1.3-0.6-2.7-0.8-4c-0.3-1.2-0.5-2.5-0.8-3.7c0-0.1,0-0.2,0-0.3c0.2-0.8,0.1-1.6,0-2.3c-0.1-0.6-0.3-1.2-0.4-1.8 c-0.1-0.2-0.1-0.5,0-0.7c0.1-0.3,0.1-0.6,0.1-1c0-0.7,0-1.3,0-2c0-0.6,0-1.1,0-1.7c0-0.9,0.1-1.7,0.2-2.6 c0.1-1.3,0.2-2.6,0.3-3.9c0.1-0.3,0.2-0.6,0.4-0.9c0,0.1,0.1,0.2,0.1,0.2c0.3,1.6,0.9,3.1,1.7,4.5c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.2,0,0.5,0,0.7c0,0.6,0.1,1.2,0.1,1.9c0,1.3,0.2,2.6,0.5,3.8c0.3,0.9,0.6,1.8,0.8,2.7c0.5,1.6,0.9,3.3,1.5,4.9 c0.2,0.6,0.4,1.2,0.7,1.8c0.1,0.2,0.1,0.3,0,0.5c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2,0.9-0.2,1.8-0.2,2.8c0,0.5,0.1,0.9,0.1,1.4 c0,0.9,0.1,1.8,0.3,2.7c0,0,0,0.1,0,0.1c0,0.7,0,1.4,0,2.1c0,0.4,0,0.9,0,1.3c0,0.2,0,0.3,0.1,0.5c0.1,0,0.2,0,0.2,0 c0.2,0,0.2,0,0.3-0.2c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1,0.1-0.2,0.1-0.3c0.1,0.4,0.2,0.8,0.2,1.2c0,0.1,0,0.2,0.1,0.2 c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0,0.3-0.2,0.3-0.3C92,81,92,80.7,92,80.4c0-0.8,0-1.7,0-2.5c0-0.1,0-0.2,0-0.3 c0.1,0.8,0.2,1.5,0.3,2.2c0.1,0.6,0.2,1.2,0.4,1.7c0.1,0.4,0.3,0.4,0.6,0.3c0,0,0.1,0,0.1-0.1c0.2-1.7-0.1-3.3-0.1-5 c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.5,0.3,0.9,0.4,1.4c0.1,0.6,0.4,1.2,0.8,1.6c0.1,0.1,0.1,0.2,0.2,0.1 s0.2-0.1,0.2-0.2c0-0.1,0-0.1,0-0.1c-0.1-0.8-0.1-1.5-0.1-2.3c-0.1-1-0.2-2.1-0.3-3.1c0.1,0.1,0.2,0.2,0.2,0.3 c0.1,0.2,0.3,0.3,0.4,0.5c0.4,0.4,0.9,0.6,1.4,0.4C97.5,76.8,97.5,76.6,97.4,76.4L97.4,76.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    style: {
      fill: "#96CDFC"
    },
    d: "M71.2,34.3c0.2,0,0.4-0.1,0.6-0.2c0-1-0.3-1.9-0.9-2.7c-1.9-2.4-5,1.4-5.7,3 c-0.3,0.7-0.5,1.4-0.8,2.1c-0.3,0.8-0.7,1.6-1,2.4c-0.5,1.6-0.8,3.3-0.9,5c-0.1,0.8-0.1,1.5,0,2.3c0.1,0.3,0.3,0.5,0.6,0.7 c1.3,0.5,2.7,0.6,4,0.2c1.5-0.2,3.4-0.5,4.4-1.8c0.5-0.8,0.7-1.8,0.6-2.8c0-0.1,0-0.1,0-0.2c-0.3-2-0.3-4-0.3-6 c0-0.2,0-0.4,0-0.6c0,0,0,0,0,0C71.4,35.3,71.2,34.8,71.2,34.3z M70,42.2C69.9,42.2,69.8,42.2,70,42.2c0.1-0.4,0-0.9-0.2-1.3 c0,0-0.1-0.1-0.1-0.1c-0.2,0.5-0.5,1-0.8,1.5c0.1,0.2,0.3,0.5,0.4,0.7c0,0.2,0.1,0.5,0,0.7c0,0.1-0.1,0.1-0.1,0 c0.1-0.3,0-0.7-0.1-0.9c-0.1-0.1-0.2-0.2-0.2-0.3c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.5-0.2,1-0.1,1.5c0.1,0.2,0.1,0.4,0,0.6 c0,0-0.1,0-0.1,0c0.1-0.4-0.2-0.9-0.2-1.3c0-0.3,0-0.6,0.2-0.9c0.2-0.5,0.5-0.9,0.7-1.4c0.3-0.5,0.4-1,0.5-1.5 c-0.1-0.4-0.2-0.7-0.4-1.1c0,0.1,0,0.3,0,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0-0.1,0-0.1,0c0-0.2,0.1-0.3,0.2-0.5 c0.1-0.2,0.1-0.4,0-0.6c0,0,0,0,0,0c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.3,0.1-0.6,0.2-0.8c-0.1,0-0.1,0-0.2-0.1 c-0.2,0.1-0.4,0.3-0.5,0.4c-0.3,0.5-0.4,1-0.4,1.6c0,0.2-0.1,0.5-0.1,0.7c0,0.3,0.3,0.5,0.4,0.9c0.1,0.2,0,0.4-0.1,0.6 c0,0.1-0.1,0-0.1,0c0.2-0.4,0-0.8-0.3-1.1c0,0-0.1-0.1-0.1-0.2c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.4,0.4-0.5,0.7 c0,0.2,0.1,0.4,0.1,0.6c0,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.4,0.8-0.7,1c-0.1,0-0.1,0-0.1-0.1c0.4-0.3,0.6-0.8,0.7-1.3 c0-0.2,0-0.4-0.1-0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.5,0.2-1,0.5-1.1,1.1c-0.1,0.4-0.1,0.8,0,1.2c0,0-0.1,0.1-0.1,0 c-0.2-0.6-0.2-1.3,0.1-1.9c0.1-0.2,0.3-0.3,0.5-0.4c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.2-0.6-0.1c-0.2,0.1-0.4,0.2-0.5,0.4 c0,0-0.1,0-0.1-0.1c0.2-0.3,0.4-0.5,0.8-0.5c0.2,0,0.3,0.1,0.4,0.1c0.2,0,0.4,0,0.6,0c0.3-0.1,0.6-0.2,0.7-0.5 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.2,0.6-0.7,0.6-1.1l0,0c-0.2,0.1-0.3,0.2-0.6,0.2c-0.3,0-0.6,0-0.8,0.2 c-0.1,0.1-0.3,0.3-0.4,0.4c0,0,0,0,0,0v0c0.2-0.2,0.4-0.5,0.7-0.6c0.1,0,0.3-0.1,0.4-0.1c0.2,0,0.4-0.1,0.6-0.2 c0-0.4,0-0.7,0.1-1.1c0.2-0.5,0.5-0.9,0.9-1.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.3,0-0.6,0-0.8,0c0,0,0,0,0,0 c-0.2,0.1-0.3,0.5-0.4,0.9c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0-0.1,0-0.1,0c0-0.1,0-0.3-0.1-0.4c0,0,0,0,0,0 c0,0,0,0,0,0.1c-0.2,0.3-0.4,0.6-0.6,0.8c0,0-0.1,0-0.1-0.1c0.4-0.4,0.6-1,0.7-1.6c0-0.1,0.1-0.2,0.1-0.3 c-0.1,0-0.2,0.1-0.2,0.1c-0.4,0.2-0.7,0.6-1,1c0,0.1-0.1,0-0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c-0.1,0-0.1,0-0.2,0 c-0.3,0-0.6,0.2-0.8,0.4c-0.3,0.4-0.5,0.7-0.8,1.1c0,0-0.1,0-0.1,0c0.2-0.5,0.5-0.9,0.9-1.3c0.1-0.1,0.3-0.2,0.4-0.3 c0.2-0.1,0.5,0,0.7-0.1c0,0,0,0,0,0c0.2-0.3,0.6-0.5,0.9-0.6c0.5,0,1.1-0.1,1.6-0.2c0-0.1-0.1-0.2-0.2-0.3 c-0.2-0.2-0.4-0.5-0.7-0.5c-0.2,0-0.3,0-0.5-0.1l0,0c-0.4,0.4-1,0.5-1.5,0.3c0,0,0-0.1,0,0c0.3,0.1,0.7,0.1,1-0.1 c0.1-0.1,0.2-0.2,0.4-0.2c-0.2-0.1-0.3-0.2-0.4-0.4c0,0,0-0.1,0.1,0c0.2,0.3,0.6,0.4,0.9,0.4c0.1,0,0.2,0,0.3,0 c-0.1-0.1-0.1-0.2-0.2-0.3C68,34.6,68,34.4,68,34.1c-0.1-0.4-0.3-0.7-0.7-1c0,0,0-0.1,0,0c0.4,0.3,0.7,0.7,0.8,1.2 c0,0.1,0,0.1,0.1,0.2c0-0.2,0-0.3,0.1-0.4c0.3-0.5,0.4-1,0.4-1.5c0,0,0,0,0,0c0.1,0.3,0,0.7-0.1,1c-0.2,0.4-0.3,0.8-0.3,1.2 c0.1,0.3,0.3,0.5,0.5,0.8c0.1,0.1,0.2,0.1,0.2,0.2l0,0c0,0,0.1,0,0.1,0.1c0.1-0.1,0.1-0.2,0.1-0.2c0.1,0.3,0.2,0.5,0.4,0.6 c0,0-0.1,0-0.1,0.1c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.2,0,0.3,0,0.5c0.1,0.3,0.6,0.2,0.7,0.4c0,0,0,0.1-0.1,0.1 c-0.1,0-0.1-0.1-0.2-0.1s-0.2-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c0.1,0.3,0.2,0.6,0.3,0.8c0.4,0.6,0.5,1.3,0.3,1.9 c0,0,0,0.1-0.1,0.2c0.2,0.2,0.3,0.5,0.4,0.8C70.1,41.6,70.1,41.9,70,42.2L70,42.2L70,42.2z M70.1,35.8C70,35.9,69.9,36,69.8,36 c-0.3-0.2-0.4-0.5-0.5-0.8c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.3-0.3,0.4-0.4c0,0,0,0,0.1,0c0.1,0.4,0.3,0.8,0.6,1.1 C70.4,35.8,70.2,35.8,70.1,35.8L70.1,35.8L70.1,35.8z M70.9,35.7c-0.4-0.3-0.7-0.7-0.8-1.2c0.2-0.2,0.6-0.2,0.8-0.2H71 c0,0.5,0.1,1,0.4,1.4C71.2,35.7,71,35.7,70.9,35.7L70.9,35.7L70.9,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    style: {
      fill: "#96CDFC"
    },
    d: "M83.6,43.9c-0.1-1.7-0.4-3.4-0.9-5c-0.3-0.8-0.6-1.6-1-2.4 c-0.3-0.7-0.5-1.4-0.8-2.1c-0.6-1.6-3.8-5.5-5.7-3c-0.6,0.8-0.9,1.8-0.9,2.8c0.2,0.1,0.5,0.2,0.8,0.2c0,0.5-0.2,1-0.5,1.4 c-0.1,0-0.2,0-0.3,0c0,0.2,0,0.4,0,0.6c0,0.4,0,0.8,0,1.2c0,1.6-0.1,3.2-0.3,4.8c0,0.1,0,0.1,0,0.2c-0.1,1,0.1,2,0.6,2.8 c0.9,1.3,2.9,1.6,4.4,1.8c1.3,0.3,2.7,0.2,4-0.2c0.3-0.1,0.5-0.4,0.6-0.7C83.7,45.4,83.7,44.6,83.6,43.9L83.6,43.9z M76.7,35 c0.1,0.2,0.2,0.3,0.3,0.5c-0.1,0.3-0.2,0.5-0.4,0.7l0,0c-0.2-0.2-0.3-0.3-0.5-0.4c0.2-0.3,0.4-0.7,0.4-1 C76.6,34.9,76.7,35,76.7,35L76.7,35L76.7,35z M74.9,35.7c0.3-0.4,0.4-0.9,0.4-1.4c0.4,0,0.7,0.2,1,0.4l0,0 c0,0.4-0.1,0.8-0.3,1.1C75.6,35.7,75.3,35.7,74.9,35.7L74.9,35.7L74.9,35.7z M81.8,41.3c-0.1-0.2-0.3-0.4-0.5-0.4 c-0.2-0.1-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0c0.2,0.1,0.3,0.3,0.5,0.4c0.3,0.6,0.3,1.3,0.1,1.9c0,0-0.1,0-0.1,0 c0.1-0.4,0.1-0.8,0-1.2C81,41.4,80.6,41.2,80,41c-0.2,0-0.4-0.2-0.6-0.3c-0.1,0.2-0.1,0.4-0.1,0.6c0.1,0.5,0.3,1,0.7,1.3 c0.1,0,0,0.1-0.1,0.1c-0.3-0.3-0.6-0.6-0.7-1c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0.1-0.4,0.1-0.6c-0.1-0.2-0.3-0.5-0.5-0.7 c-0.2-0.1-0.3-0.3-0.5-0.5c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.7-0.3,1.1c0,0.1-0.1,0.1-0.1,0c-0.1-0.2-0.1-0.4-0.1-0.6 c0.1-0.3,0.3-0.5,0.4-0.9c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.5-0.1-1.1-0.4-1.6c-0.1-0.2-0.3-0.3-0.5-0.4c0,0-0.1,0.1-0.2,0.1 c0.1,0.3,0.2,0.5,0.3,0.8c0,0.4-0.1,0.8-0.3,1.2c0,0,0,0,0,0c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.1,0.2,0.3,0.2,0.5c0,0-0.1,0-0.1,0 c0-0.2-0.2-0.3-0.2-0.5c0-0.1,0-0.3,0-0.4c-0.2,0.3-0.3,0.7-0.4,1.1c0,0.5,0.2,1,0.5,1.5c0.2,0.5,0.5,0.9,0.7,1.4 c0.1,0.3,0.2,0.6,0.1,0.9c0,0.4-0.3,1-0.2,1.3c0,0.1-0.1,0.1-0.1,0c-0.1-0.2-0.1-0.4,0-0.6c0.2-0.5,0.1-1-0.1-1.5 c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.2,0.6-0.1,0.9c0,0.1-0.1,0.1-0.1,0c0-0.2,0-0.5,0-0.7 c0.1-0.2,0.2-0.5,0.4-0.7c-0.3-0.5-0.5-1-0.8-1.5c0,0-0.1,0.1-0.1,0.1c-0.3,0.4-0.3,0.8-0.2,1.2c0,0.1-0.1,0.1-0.1,0 c-0.1-0.3-0.2-0.5-0.1-0.8c0.1-0.3,0.2-0.5,0.4-0.8c0-0.1,0-0.1-0.1-0.2c-0.2-0.7-0.1-1.3,0.3-1.9c0.1-0.3,0.2-0.5,0.3-0.8 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.1c0.2-0.2,0.6-0.1,0.7-0.4 c0-0.2,0-0.3,0-0.5c-0.1-0.2-0.1-0.4-0.2-0.5c0.2-0.2,0.3-0.4,0.4-0.6c0,0,0.1,0,0.1-0.1l0,0c0.1-0.1,0.1-0.2,0.2-0.2 c0.2-0.2,0.3-0.5,0.5-0.8c0-0.4-0.1-0.8-0.3-1.2c-0.1-0.3-0.2-0.7-0.1-1c0,0,0,0,0,0c0,0.5,0.2,1.1,0.4,1.5 c0.1,0.1,0.1,0.3,0.1,0.4c0-0.1,0-0.1,0.1-0.2c0.1-0.5,0.4-0.9,0.8-1.2c0,0,0.1,0,0,0c-0.3,0.3-0.5,0.6-0.7,1 c0,0.2-0.1,0.5-0.2,0.7C78,35,77.9,35,77.9,35.1c0.1,0,0.2,0,0.3,0c0.3,0,0.7-0.1,0.9-0.4c0,0,0.1,0,0.1,0 c-0.1,0.2-0.2,0.3-0.4,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.3,0.2,0.7,0.2,1,0.1c0,0,0.1,0,0,0c-0.5,0.2-1.1,0.1-1.5-0.3l0,0 c-0.2,0-0.3,0-0.5,0.1c-0.3,0-0.5,0.4-0.7,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.5,0.1,1.1,0.2,1.6,0.2c0.3,0.1,0.7,0.3,0.9,0.6 c0,0,0,0,0,0c0.2,0.1,0.4,0,0.7,0.1c0.2,0,0.3,0.2,0.4,0.3c0.3,0.4,0.6,0.8,0.8,1.3c0,0-0.1,0.1-0.1,0c-0.2-0.4-0.5-0.8-0.8-1.1 C80.7,37.1,80.4,37,80,37c-0.1,0-0.1,0-0.2,0c0.1,0.2,0.2,0.3,0.4,0.5c0,0.1,0,0.1-0.1,0.1c-0.2-0.4-0.6-0.7-1-1 c-0.1,0-0.2-0.1-0.2-0.1c0.1,0.1,0.1,0.2,0.1,0.3c0.1,0.6,0.3,1.1,0.7,1.6c0,0,0,0.1-0.1,0.1c-0.2-0.3-0.4-0.5-0.6-0.8 c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3 c-0.1-0.3-0.1-0.8-0.4-0.9c0,0,0,0,0,0c-0.3,0-0.6,0-0.8,0c-0.2,0-0.4,0-0.6-0.1c0.4,0.3,0.7,0.7,0.9,1.2 c0.1,0.3,0.1,0.7,0.1,1.1c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4,0.1c0.3,0.1,0.5,0.4,0.7,0.6c0,0,0,0,0,0h0 c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2-0.2-0.5-0.2-0.8-0.2c-0.2,0-0.4,0-0.6-0.2l0,0c0,0.5,0.2,0.9,0.6,1.1c0.2,0.1,0.3,0.2,0.4,0.3 c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.4,0.4,0.7,0.5c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.4-0.1C81.5,40.8,81.8,41,81.8,41.3 C82,41.3,81.9,41.4,81.8,41.3L81.8,41.3L81.8,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    style: {
      fill: "#96CDFC"
    },
    d: "M73.9,30.1V29c-0.5,0.3-1.1,0.3-1.6,0v1C72.8,30.4,73.4,30.4,73.9,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    style: {
      fill: "#96CDFC"
    },
    d: "M73.9,28.8v-1.2c-0.5,0.3-1.1,0.3-1.6,0.1v1.1C72.6,29.1,73.4,29,73.9,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    style: {
      fill: "#96CDFC"
    },
    d: "M73.9,31.5v-1.1c-0.5,0.3-1.1,0.3-1.6,0v1C72.8,31.8,73.4,31.8,73.9,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    style: {
      fill: "#96CDFC"
    },
    d: "M73.9,32.6v-0.9c-0.5,0.3-1.1,0.3-1.6,0v0.8C72.8,32.8,73.4,32.9,73.9,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    style: {
      fill: "#96CDFC"
    },
    d: "M73.9,33.7C73.9,33.7,73.9,33.6,73.9,33.7l0-0.9c-0.5,0.2-1.1,0.2-1.6,0v0.8 c0,0,0,0,0,0.1c0,0,0,0,0,0C72.8,34,73.4,34,73.9,33.7L73.9,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    style: {
      fill: "#96CDFC"
    },
    d: "M72.2,33.9c0,0.6,0.2,1.2,0.5,1.6h0.8c0.2-0.5,0.4-1.1,0.4-1.7 C73.4,34.1,72.8,34.2,72.2,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    style: {
      fill: "#96CDFC"
    },
    d: "M74.4,34.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.6-0.2,1.1-0.4,1.6c0.1,0,0.3,0,0.3,0 c0.1,0,0.2,0.1,0.3,0.1C74.3,35.1,74.3,34.6,74.4,34.1L74.4,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9522",
    style: {
      fill: "#96CDFC"
    },
    d: "M71.8,34.1c0,0.5,0,1,0,1.5c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2,0,0.3,0 c-0.3-0.5-0.4-1.1-0.4-1.6C71.9,34,71.9,34,71.8,34.1L71.8,34.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    style: {
      fill: "#96CDFC"
    },
    d: "M83,66.9c-0.1-0.3-0.2-0.6-0.4-0.8c0-0.3,0-0.6,0-0.9c0-0.4-0.1-0.7-0.3-1 c0,0,0,0,0-0.1c0.2-0.4,0.1-0.9,0-1.3c0.2-0.4,0.4-0.8,0.4-1.3c0.1-0.4-0.1-0.8-0.4-1.1c0.4-0.5,0.4-1.2,0.1-1.8 c-0.1-0.2-0.4-0.4-0.6-0.5c0,0-0.1-0.1-0.1-0.1c-0.6-0.5-1.4-0.6-2.1-0.3c-0.3,0.1-0.5,0.3-0.6,0.6c-0.3,0-0.6,0-0.9,0 c-0.5,0.1-0.9,0.4-1.1,0.8c-0.3,0-0.6,0-0.9,0.1c-0.4,0.1-0.7,0.3-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.1c-0.4-0.1-0.7,0-1.1,0.1 c-0.2,0.1-0.4,0.2-0.5,0.4c0,0-0.1-0.1-0.1-0.1c-0.3-0.3-0.7-0.4-1.2-0.5c-0.4,0-0.7,0.1-1,0.3c0,0,0,0,0,0 c-0.2-0.4-0.7-0.8-1.1-0.9c-0.1,0-0.2,0-0.4,0c-0.7-0.7-1.5-1.4-2.5-1c-1.2,0.5-1.5,1.6-1.5,2.8c-0.2,0.6-0.3,1.2-0.2,1.9 c0.1,0.5,0.2,1,0.4,1.5c-0.3,0.6-0.4,1.3-0.5,1.9c0,0.5,0.1,0.9,0.4,1.4c-0.2,0.6-0.3,1.2-0.1,1.8c0,0,0,0.1,0,0.1 c-0.1,0.4-0.2,0.7-0.2,1.1c-0.2,1.7,1.3,3.3,3,2.6c1.9-0.8,2.1-2.8,1.7-4.5c0.2-0.6,0.3-1.3,0-1.9l0,0c0.3-0.4,0.5-0.8,0.6-1.3 c0.1-0.5-0.1-1.1-0.5-1.4c1,0.3,2.1,0.4,3.2,0.2c1.3-0.2,2.7-0.6,4-1c0.4-0.1,0.7-0.3,1.1-0.5c-0.1,0.9-0.1,1.9,0,2.8 c0.1,1,0.4,2,0.8,2.9c0.1,0.3,0.2,0.5,0.3,0.8c-0.2-0.1-0.4-0.2-0.7-0.2c-0.4-0.1-0.8,0-1.1,0.1c-0.2-0.2-0.4-0.5-0.6-0.6 c-0.4-0.3-1-0.3-1.5-0.2c-0.3-0.1-0.6-0.2-0.9-0.1c-1.2,0.2-2.1,1-2.4,2.2c-0.2,1-0.1,2,0.2,2.9c0.1,0.6,0.2,1.2,0.4,1.8 c0.2,0.6,1,0.2,0.9-0.3c-0.1-1,0-1.9,0.2-2.9c0-0.1,0.1-0.2,0.1-0.2c0.2,0,0.4,0.2,0.8,0.4c0.6,0.4,1.3,0.7,2,0.9 c1.5,0.3,3,0.2,4.4-0.6c1-0.6,1.7-1.7,1.8-2.9c0-0.3,0-0.6-0.1-0.9C83.1,68.1,83.1,67.5,83,66.9L83,66.9z M67.7,64.8 C67.7,64.8,67.7,64.8,67.7,64.8c0,0.2,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0,0.1c-0.6,0.2-0.7,1.2-0.7,1.8c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0.1c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.2,0.2 c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1,0,0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3l0,0c-0.2,0.2-0.3,0.3-0.4,0.5 c-0.1,0.2-0.2,0.4-0.2,0.6l0,0v0.2c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.3,0.3,0.5,0.3 c0.1,0,0.1,0,0.2,0.1c0.1,0,0,0.1-0.1,0.1s-0.1,0-0.2,0c-0.2,0-0.6,0-0.6,0.4v0.5c0,0.3,0.1,0.6,0.2,0.8c0,0,0,0,0,0 c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0.1-0.1,0.1c-0.3-0.3-0.5-0.6-0.6-1c-0.2,0.3-0.5,0.4-0.8,0.3c-0.1,0,0-0.1,0-0.1 c0.4,0.1,0.6-0.2,0.7-0.6c0-0.1,0-0.2,0-0.3V71l0,0c0-0.2,0-0.5-0.1-0.7c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.1,0-0.1,0 c-0.1,0-0.3-0.1-0.4-0.2c0,0,0-0.1,0.1-0.1c0.1,0.1,0.3,0.2,0.5,0.1c0,0,0,0,0-0.1c0.4-0.3,0.3-0.6,0.4-1c0,0,0-0.1,0-0.1 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.8c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.3-0.4-0.5-0.5 c0,0,0-0.1,0,0c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.4 c0,0,0,0,0-0.1c0-0.3,0-0.6,0.1-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.4-0.4-0.7-0.6c0,0,0-0.1,0,0c0.2,0.1,0.5,0.3,0.7,0.5 c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0.1-0.1,0.1-0.2v-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.6c0,0,0,0-0.1,0 c-0.3-0.2-0.6-0.5-0.7-1l0,0c-0.3-0.1-0.5-0.4-0.7-0.7c-0.1-0.3-0.2-0.7-0.1-1c0,0,0,0,0,0c-0.1,0.6,0.2,1.2,0.7,1.6 c0-0.2-0.1-0.4,0-0.6c0,0,0.1-0.1,0.1,0c0,0.8,0.5,1.4,1.2,1.6c0.7,0.2,1.3,0.4,2,0.6c0,0,0,0.1,0,0.1c-0.4,0-0.9-0.1-1.3-0.2 c-0.3-0.1-0.7-0.2-1-0.3C67.8,64,67.8,64.4,67.7,64.8L67.7,64.8L67.7,64.8z M68.7,72.2C68.7,72.3,68.6,72.2,68.7,72.2 c0.6-0.6,1-1.5,0.8-2.4c0,0,0-0.1,0.1,0C69.7,70.6,69.6,71.9,68.7,72.2L68.7,72.2L68.7,72.2z M69.4,68.7 C69.4,68.7,69.4,68.7,69.4,68.7C69.4,68.7,69.4,68.7,69.4,68.7c0-0.2,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.3,0.1-0.4c0,0,0,0,0,0 C69.8,68.2,69.7,68.6,69.4,68.7L69.4,68.7L69.4,68.7z M70,65.4C70,65.4,70,65.4,70,65.4c0,0.6-0.1,1.3-0.8,1.6 c-0.1,0-0.1-0.1,0-0.1C69.7,66.5,70,66,70,65.4L70,65.4L70,65.4z M71,64.2c-0.7,0.1-1.3-0.2-1.7-0.8c0,0,0,0,0,0 c0.2,0.3,0.5,0.5,0.8,0.6C70.4,64,70.7,64.1,71,64.2C71,64.1,71,64.2,71,64.2L71,64.2L71,64.2z M75.4,62.1c-0.7-0.5-1.3-0.1-2,0 c-0.2,0.1-0.5,0-0.7,0l0,0c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1,0,0.2,0,0.3 c0,0.1-0.1,0.1-0.1,0c0-0.3-0.1-0.7-0.3-0.9c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.2-1.1-0.2-1.6-0.1c0,0.2-0.1,0.4-0.2,0.6 c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2c-0.2-0.5-0.8-0.8-1.3-0.8c0,0,0,0,0,0 c0,0,0,0-0.1,0.1c0,0-0.1,0,0,0c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.3-0.4-0.4-0.5c-0.4-0.3-0.7-0.1-1.1,0 c-0.1,0-0.1,0,0-0.1c0.2-0.1,0.3-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.3,0.5,0.6c0.3,0.2,0.6,0.2,0.9,0.1 c0,0,0.1,0,0.1,0c0.1,0,0,0.1,0,0.1c-0.1,0-0.2,0-0.3,0h0c0,0,0,0,0,0c-0.2,0.1-0.2,0.4-0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.3l0,0 c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.2,0.9,0.1,1.3-0.2c0.1,0,0.1,0,0,0.1c0,0,0,0,0,0c-0.2,0.1-0.3,0.3-0.2,0.5c0.1,0,0.2,0,0.2,0.1 c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2,0,0.1,0.1h0l0,0c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0.2,0.1,0.2,0.2l0,0 c0.3,0.1,0.6,0.1,0.9,0.1h0c0.3,0,0.6-0.2,0.8-0.4l0,0c0.1,0,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.1-0.2 c0,0,0,0,0.1,0c0-0.1,0-0.2,0-0.3c0,0,0.1-0.1,0.1,0c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0.2,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1,0h0c0,0,0,0,0,0c0.2-0.1,0.4-0.2,0.6-0.2c0.5-0.2,1-0.5,0.9-1.2 c0,0,0.1-0.1,0.1,0c0.1,0.2,0.1,0.5-0.1,0.7c0,0.1,0,0.2,0.1,0.2c0.2-0.1,0.4-0.1,0.7-0.2c0,0,0.1,0,0.1,0 c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.2,0.3-0.4,0.3-0.6c0-0.1,0-0.3-0.1-0.4c0,0,0-0.1,0.1-0.1 c0.2,0,0.2,0.2,0.2,0.4c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.1,0.2,0.2c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3 c0.3-0.3,0.7-0.5,1.1-0.5c0.1,0,0,0.1,0,0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.4,0.3-0.5,0.5 c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l0,0h0.3v0c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.2-0.8,0.3 c-0.1,0-0.2,0-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1,0,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1 c0,0,0,0.1,0,0c0,0,0,0-0.1,0l0,0c-0.2-0.1-0.5-0.1-0.8-0.2c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.8,0.2-1.1,0.3 c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1C75.3,61.7,75.4,61.8,75.4,62.1 C75.4,62,75.4,62.1,75.4,62.1L75.4,62.1L75.4,62.1z M69,59.7L69,59.7L69,59.7L69,59.7z M75.3,70.9c-0.4,0.4-1,0.7-1.6,0.6 c-0.3,0-0.8-0.1-0.9-0.4c0,0,0-0.1,0,0c0.1,0.3,0.7,0.3,1.1,0.3C74.4,71.3,74.8,71.1,75.3,70.9C75.3,70.7,75.3,70.8,75.3,70.9 C75.3,70.9,75.3,70.9,75.3,70.9z M82.2,67.8c-0.1,0.1-0.2,0.3-0.3,0.4c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1 c-0.1,0.2-0.5,0.6-0.1,0.8c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.3,0.5,0.2,0.7c0,0-0.1,0.1-0.1,0c0-0.3-0.1-0.5-0.3-0.7 c0,0,0,0,0,0c-0.4-0.1-0.9,0.1-1.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c-0.4,0.1-0.8,0.3-1.1,0.5 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.4,0-0.8-0.1-1.2-0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0 c0,0,0,0,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0 c-0.2-0.1-0.3-0.3-0.4-0.5c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.2-0.1-0.4-0.1-0.7,0c-0.2,0.1-0.3,0.2-0.4,0.3 c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1v0c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.2,0.1-0.5,0-0.7c0,0,0,0,0-0.1c-0.3-0.3-0.7-0.5-1.2-0.4c0,0,0-0.1,0-0.1c0.4,0,0.8-0.1,1.1,0.2c0.2,0.2,0.3,0.4,0.4,0.7 c0.3-0.1,0.7,0,0.9,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.8,0.1,1.1,0 c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.2,0.4-0.3,0.5-0.5c0.1-0.1,0.2-0.2,0.4-0.3h0c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.4 c0,0,0,0,0,0c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.2-0.1-0.5-0.4-0.6c-0.3-0.1-0.5-0.2-0.7-0.4c0,0,0-0.1,0.1,0 c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.2,0.1,0.5,0.2,0.6-0.1c0-0.2,0-0.3,0-0.5c0,0,0,0,0-0.1c0-0.1,0-0.3-0.1-0.4 c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.5,0.3,0.6,0.2 c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3-0.1-0.4c-0.1-0.2-0.2-0.4-0.2-0.6l0,0c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2-0.1-0.3c0,0,0-0.1,0.1,0c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.3,0.3,0.4 c-0.1-0.2-0.1-0.4,0-0.6c0-0.2,0.3-1,0.1-1.1c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.2c-0.6,0.3-1.2,0.3-1.8,0.7c0,0-0.1,0-0.1,0 c-0.1,0.2-0.3,0.3-0.5,0.4c-0.5,0.2-1,0.4-1.5,0.5c0,0-0.1-0.1,0-0.1c0.4-0.2,0.9-0.3,1.3-0.5c0.4-0.2,0.7-0.5,1-0.9 c0,0,0,0,0,0s0,0,0,0l0,0c-0.1,0.2-0.2,0.3-0.3,0.5c0.3-0.2,0.7-0.4,1.1-0.5c0.3-0.1,0.7-0.2,1-0.5c0.2-0.2,0.4-0.5,0.5-0.7 c0,0,0.1,0,0.1,0c-0.1,0.2-0.2,0.4-0.2,0.6c0.3-0.1,0.5-0.3,0.8-0.5c0.2-0.1,0.3-0.3,0.4-0.6c0-0.1,0.1-0.2,0.1-0.3 c0,0,0.1,0,0.1,0c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.4c-0.3,0.3-0.6,0.5-1,0.6c0,0,0,0-0.1,0 c0.1,0.1,0.2,0.3,0.1,0.5c0,0.3-0.2,1.3,0.4,1.3c0,0,0,0,0,0c0.1-0.2,0.3-0.3,0.4-0.5c0,0,0,0,0.1,0s0,0,0,0.1c0,0,0,0,0,0 c-0.2,0.2-0.4,0.5-0.5,0.8c-0.1,0.4-0.1,0.7,0,1.1c0.1,0.3,0.2,0.7,0.5,0.8c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0,0.1 c-0.3,0.2-0.5,0.5-0.6,0.9c0,0.3,0,0.6,0.2,0.7c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0.1,0,0.1c-0.1,0.1-0.4,0.2-0.4,0.4 c0,0.2,0.1,0.3,0.2,0.5c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3-0.1l0,0C81.9,68.1,82,67.9,82.2,67.8 C82.1,67.8,82.2,67.8,82.2,67.8L82.2,67.8L82.2,67.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    style: {
      fill: "#96CDFC"
    },
    d: "M74.4,49.1c-0.8-0.3-1.6-0.4-2.4-0.2c-0.2,0.1-0.2,0.1-0.4,0 c-0.6-0.2-1.2-0.2-1.7,0c-0.6,0.2-1.2,0.2-1.8,0c-0.8-0.2-1.5,0-2.2,0.4c-1.3,0.9-1.3,1.7-1.3,2.9s0.1,2.2,0.1,2.8 s-0.1,1.2,0.2,1.5c0,0,0,0,0.1,0.1c0.3,0.2,0.4-0.1,0.8-0.5c0.6-0.5,1.2-0.9,1.9-1.2c0.4-0.2,0.8-0.4,1.1-0.7 c0.1,0,0.1-0.1,0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.1c0,0,0,0-0.1,0c-0.2,0.1-0.4,0-0.6,0c-0.2-0.1-0.4-0.1-0.6,0 c-0.4,0.1-0.8,0-1-0.3c-0.3-0.2-0.3-0.6-0.1-0.9c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0,0.1-0.1,0.2-0.1c0,0-0.1,0-0.1,0c0.2-0.1,0.3,0,0.5,0.2c0.2,0.2,0.5,0.5,0.6,0.5c0.2,0,0.3,0.2,0.4,0.3 c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0.1c0.1-0.1,0.2-0.2,0.2-0.3 c0-0.3,0-0.6,0-0.9c0.1-0.6,0.5-1.1,1-1.4c0.5-0.3,0.6-0.4,0.4-0.7l0.1,0.1c0.1,0.2,0.1,0.3-0.2,0.5c0.2-0.1,0.4-0.1,0.6-0.1 l0.2,0c0.1,0,0.3,0,0.3-0.1c0,0,0,0.1-0.2,0.1c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4-0.1-0.7,0-1.1,0.2l-0.1,0 c-0.1,0.1-0.2,0.2-0.4,0.3c0.1,0,0.2,0,0.4,0c0.3,0,0.6,0,0.8-0.1c-0.2,0.1-0.4,0.2-0.6,0.2c0.3,0,0.5,0,0.8-0.2 c0,0-0.3,0.3-1,0.2c-0.2,0-0.3,0-0.5,0c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.2,0,0.4,0,0.6c0,0,0.1-0.1,0.1-0.1 c0.2-0.2,0.3-0.1,0.6-0.2c0.4-0.2,0.8-0.6,1.1-0.9c0.4-0.2,0.7-0.5,1-0.8c0.3-0.3,0.7-0.6,1.1-0.8c0.4-0.3,0.6-0.4,1-0.7 c0.6-0.3,0.8-0.2,0.8-0.4C75.1,49.3,74.9,49.2,74.4,49.1L74.4,49.1z M66.2,52.9C66.2,52.9,66.2,52.8,66.2,52.9 C66.2,52.8,66.2,52.8,66.2,52.9L66.2,52.9z M66.1,53.1L66.1,53.1L66.1,53.1z M66.1,53C66.1,53,66.1,52.9,66.1,53 C66.2,52.9,66.2,52.9,66.1,53L66.1,53z M66.6,52.6L66.6,52.6L66.6,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    style: {
      fill: "#96CDFC"
    },
    d: "M69.3,54.2c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0.1-0.1,0.1c0.1,0,0.1,0.1,0.1,0.1 c0.2,0.2,0.3,0.5,0.3,0.9c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0s0-0.1,0-0.1c0-0.2-0.1-0.4-0.2-0.6 c0-0.2-0.1-0.5-0.1-0.9c0,0-0.1,0.1-0.1,0.1C69.3,53.8,69.3,54,69.3,54.2L69.3,54.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    style: {
      fill: "#96CDFC"
    },
    d: "M81,50.9c-0.2-0.9-0.7-1.8-1.3-2.4c-0.4-0.5-1-0.8-1.7-0.9c-0.3,0-0.6,0-0.8,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.3-0.4-0.4-0.7c-0.2-0.4-0.3-0.7-0.3-1.1 c-0.1-0.4,0-0.6-0.3-0.8c-0.2-0.1-0.5-0.1-0.8,0c-0.2,0.1-0.3,0.2-0.3,0.6c0,0.4,0,0.8,0.1,1.2c0.1,0.3,0.2,0.6,0.4,0.9 c0.2,0.3,0.4,0.6,0.6,0.8c0.2,0.2,0.4,0.4,0.4,0.8c0,0.2-0.1,0.4-0.1,0.5c-0.1,0.3-0.1,0.7-0.1,1s0.2,0.6,0.2,1 c0.1,0.5,0,1.1-0.3,1.5c-0.2,0.4-0.4,0.7-0.7,1c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.1-0.7,0.1c-0.3,0-0.6,0.1-0.8,0.3 c-0.1,0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.5-0.2-0.8-0.1c-0.2,0.1-0.4,0.2-0.6,0.4 c-0.2,0.3-0.2,0.6-0.3,0.6c-0.2,0.1-0.4,0.3-0.6,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3-0.1,0.4 c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.4-0.1,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2-0.7,0.4,0.7,0.4c1.4,0,0.5-0.2,0.7-0.5 c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.5c-0.1-0.3-0.2-0.4,0.1-0.6c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0.1-0.2,0.1-0.4 c0-0.1,0-0.2,0-0.3c0-0.1,0.1,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.4 c0.2,0.3,0.4,0.5,0.7,0.7s0.5,0.3,0.8,0.5c0.9,0.4,1.9,0.5,2.9,0.3c0.9-0.2,1.8-0.7,2.4-1.3c1.1-1,1.8-2.4,1.9-3.8 c0.1-0.4,0.1-0.8,0.1-1.2C81.1,51.7,81.1,51.3,81,50.9L81,50.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18491"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    style: {
      fill: "#B9DEFD"
    },
    cx: 73.3,
    cy: 66.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    style: {
      fill: "#0564B7"
    },
    d: "M73.3,68.3c-0.1,0-0.2-0.1-0.3-0.2l-1.9-2.3c-0.2-0.2-0.1-0.4,0.1-0.6l0,0 c0.2-0.2,0.4-0.1,0.6,0.1l1.5,1.8l2.7-4.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-3,5 C73.6,68.2,73.4,68.3,73.3,68.3L73.3,68.3L73.3,68.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18493"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289",
    style: {
      fill: "#B9DEFD"
    },
    cx: 78.1,
    cy: 54.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    style: {
      fill: "#0564B7"
    },
    d: "M78.1,56.2c-0.1,0-0.2-0.1-0.3-0.2l-1.9-2.3c-0.2-0.2-0.1-0.5,0.1-0.6l0,0 c0.2-0.2,0.4-0.1,0.6,0.1l0,0L78,55l2.7-4.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-3,5 C78.4,56.1,78.2,56.1,78.1,56.2L78.1,56.2L78.1,56.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18495"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_290",
    style: {
      fill: "#B9DEFD"
    },
    cx: 67.3,
    cy: 52,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9529",
    style: {
      fill: "#0564B7"
    },
    d: "M67.3,54c-0.1,0-0.2-0.1-0.3-0.2l-1.9-2.3c-0.2-0.2-0.1-0.5,0.1-0.6l0,0 c0.2-0.2,0.4-0.1,0.6,0.1l0,0l1.5,1.8l2.7-4.5c0.1-0.2,0.4-0.3,0.6-0.2s0.3,0.4,0.2,0.6l-3,5C67.6,53.9,67.5,54,67.3,54 L67.3,54L67.3,54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18497"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_291",
    style: {
      fill: "#B9DEFD"
    },
    cx: 67.2,
    cy: 38.6,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9530",
    style: {
      fill: "#0564B7"
    },
    d: "M67.2,40.6c-0.1,0-0.2-0.1-0.3-0.2L65,38.2c-0.2-0.2-0.1-0.5,0.1-0.6l0,0 c0.2-0.2,0.4-0.1,0.6,0.1l1.5,1.8l2.7-4.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-3,5 C67.5,40.5,67.4,40.6,67.2,40.6L67.2,40.6L67.2,40.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18499"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_292",
    style: {
      fill: "#B9DEFD"
    },
    cx: 78.3,
    cy: 40.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    style: {
      fill: "#0564B7"
    },
    d: "M78.3,42.8c-0.1,0-0.2-0.1-0.3-0.2l-1.9-2.3c-0.2-0.2-0.1-0.5,0.1-0.6l0,0 c0.2-0.2,0.4-0.1,0.6,0.1l1.5,1.8l2.7-4.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-3,5 C78.6,42.7,78.5,42.7,78.3,42.8L78.3,42.8L78.3,42.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9532",
    style: {
      fill: "#FFB27D"
    },
    d: "M58.1,49.8c0,0,0.3-0.6,0.4-0.9s0.9-1.1,1-0.9s0.6,1.4,0.3,1.8s0,1-1.3,1.3 L58.1,49.8L58.1,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9533",
    style: {
      fill: "#B9DEFD"
    },
    d: "M43.7,46.1c0,0,6.6,5.5,9.2,5c1.7-0.4,3.4-0.9,5.1-1.5l0.6,1.6 c0,0-2.8,3.8-5.7,3.8c-2.7,0-5.5-0.7-7.9-2L43.7,46.1L43.7,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9534",
    style: {
      fill: "#0564B7"
    },
    d: "M32.1,104.4c0,0,0.2,3.1,0.8,3.1c0.1,0,3,0,3,0l3.8,0c-0.1-0.6-0.5-1.1-1.1-1.1 c-1.5-0.2-2.8-1.1-3.6-2.4C34.3,102.4,32.1,104.4,32.1,104.4L32.1,104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9535",
    style: {
      fill: "#2E9BF9"
    },
    d: "M31.9,104.6c0.7,0.2,1.4,0.3,2,0.4c0.7,0,1.3-0.1,1.9-0.3c0.3-2.3,0.8-4.5,1.4-6.7 c0.6-2.4,1.5-5.5,2.8-9.4c2-5.7,3.5-11.6,4.7-17.5v-0.1l0,0L34,66.3c0,0,1.3,14.7-0.4,20.3c-0.3,0.9-0.5,1.8-0.6,2.7 C32.3,94.4,31.9,99.5,31.9,104.6L31.9,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9536",
    style: {
      fill: "#0B8AF8"
    },
    d: "M37.3,98c0.6-2.4,1.5-5.5,2.8-9.4c2-5.7,3.5-11.6,4.7-17.5v-0.1L34,66.3 c0,0,1.3,14.7-0.4,20.3C33.3,87.5,37.3,98,37.3,98L37.3,98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9537",
    style: {
      fill: "#0564B7"
    },
    d: "M40.5,104.4c0,0,0.2,3.1,0.8,3.1c0.1,0,3,0,3,0l3.8,0c-0.1-0.6-0.5-1.1-1.1-1.1 c-1.5-0.2-2.8-1.1-3.6-2.4C42.7,102.4,40.5,104.4,40.5,104.4L40.5,104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9538",
    style: {
      fill: "#51ABFA"
    },
    d: "M46.7,66.7c0,7.1-0.5,14.2-1.5,21.2c-1.7,11.7-1.1,16.7-1.1,16.7 c-0.5,0.2-1,0.3-1.6,0.4c-0.8,0-1.6-0.1-2.4-0.3c0,0-2.4-11.7-1.7-17.6s-3.2-20.1-3.2-20.1L46.7,66.7L46.7,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9539",
    style: {
      fill: "#FFB27D"
    },
    d: "M43.4,42.9c0,0.8-0.3,1.5-0.8,2.2l-1.5,0.7L39,44.4c0.5-1.2,0.7-2.5,0.6-3.7 c0-0.1-0.1-1-0.1-1l1.1,0.5l2.8,1.2C43.5,41.9,43.5,42.4,43.4,42.9L43.4,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    style: {
      fill: "#FFFFFF"
    },
    d: "M47.3,67.1c0,5-0.4,16.8-0.6,17c-2.6,2.5-14.1-0.7-14.7-3.5s2.3-35.7,6.8-37 c0.9-0.3,5.9,1.3,5.9,1.3c0.5,1.5,1,3,1.3,4.6c0.2,1,0.8,7.8,1.2,12.4c0.1,1.2,0.2,2.3,0.2,3C47.3,65.3,47.3,66.1,47.3,67.1 L47.3,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    style: {
      fill: "#ED985F"
    },
    d: "M43.4,42.9c-1.1-0.4-3-1.2-3.6-2.2c-0.3-0.4,0.1-0.6,0.8-0.6l2.8,1.2 C43.5,41.9,43.5,42.4,43.4,42.9L43.4,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    style: {
      fill: "#FFB27D"
    },
    d: "M44.5,41.3c0,0-4.6,1.4-5.4-1.4s-2-4.6,0.9-5.6s3.8-0.1,4.3,0.8 S45.6,40.8,44.5,41.3L44.5,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    style: {
      fill: "#56130F"
    },
    d: "M44,34.7c0,0-0.3,3.3-1,3.2s-1.3-0.2-1.2,0.8s-0.1,2.2-2.2,2.4s-4-5.4-3.4-6.4 C37.9,31.6,46.5,31,44,34.7L44,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    style: {
      fill: "#B9DEFD"
    },
    d: "M43.4,43.7c-0.1,0-3.4-1.5-3.8-1.4s-0.9,1.3-0.9,1.3l5.9,1.3 C44.3,44.4,43.9,44,43.4,43.7L43.4,43.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    style: {
      fill: "#0B1A3B"
    },
    d: "M65,60.6L47.8,78.8c-0.3,0.3-0.9,0.4-1.3,0l-1.2-1.1c-0.4-0.3-0.4-0.9-0.1-1.3 l17.2-18.3c0.3-0.3,0.6-0.1,1,0.3l1.2,1.1C65.1,59.9,65.4,60.2,65,60.6L65,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    style: {
      fill: "#0B1A3B"
    },
    d: "M55.6,70.6l-7.7,8.2c-0.3,0.4-0.9,0.4-1.3,0l-1.2-1.1c-0.4-0.3-0.4-0.9,0-1.3 l7.7-8.2L55.6,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    style: {
      fill: "#0B1A3B"
    },
    d: "M87.8,44.1c-0.6-1.8-1.6-3.5-2.9-4.9c-0.2-0.2-0.4-0.5-0.7-0.7 c-0.1-0.1-0.2-0.2-0.2-0.2c-4.6-4.3-11.5-5.2-17-2.2c-1.4,0.8-2.6,1.7-3.7,2.9c-2.3,2.4-3.7,5.5-3.9,8.9c0,0.1,0,0.3,0,0.4 c0,0.5,0,1,0,1.6c0,0.4,0,0.7,0.1,1.1c0.1,0.8,0.3,1.7,0.5,2.5c0.5,1.8,1.4,3.5,2.6,5c0.4,0.5,0.9,1,1.3,1.5 c0.4,0.3,0.7,0.7,1.1,1c5.6,4.3,13.4,4,18.7-0.6c0.3-0.3,0.7-0.6,1-1C88.4,55.1,89.6,49.3,87.8,44.1L87.8,44.1z M84,58.4 c-0.5,0.6-1.1,1.1-1.8,1.6c-1.5,1.1-3.2,1.9-5.1,2.4c-0.3,0.1-0.7,0.2-1,0.2c-0.1,0-0.2,0-0.3,0h-0.1c-2,0.3-4,0.1-5.9-0.5 c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.6-0.2-0.9-0.4l0,0c-0.7-0.3-1.4-0.7-2-1.1c-0.3-0.2-0.6-0.4-0.8-0.6 c-0.3-0.3-0.7-0.6-1-0.9c-0.2-0.2-0.3-0.3-0.5-0.5c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2 s-0.1-0.2-0.2-0.2c0,0,0,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1S63,57.4,63,57.4c0,0,0,0,0-0.1 c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.2-0.2-0.3-0.3-0.5l0-0.1c0,0-0.1-0.1-0.1-0.2l-0.1-0.1c0,0-0.1-0.1-0.1-0.1S62.1,56,62.1,56 c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.2s0-0.1-0.1-0.1s0-0.1-0.1-0.1s-0.1-0.1-0.1-0.2 c-0.1-0.3-0.3-0.6-0.4-0.9c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2 c0,0,0,0,0-0.1c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2v-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3 c0-1.1,0.1-2.1,0.3-3.2c0.1-0.5,0.2-1,0.4-1.5c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.3-0.6,0.5-0.9 c0.2-0.3,0.3-0.6,0.5-0.8l0,0c0.1-0.2,0.2-0.4,0.4-0.5c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.3,0.6-0.7,0.9-1c0.1-0.1,0.2-0.2,0.3-0.3 c0.4-0.4,0.9-0.8,1.4-1.2c0.3-0.3,0.7-0.5,1.1-0.8c0,0,0.1,0,0.1-0.1c0.4-0.3,0.9-0.5,1.3-0.7c0.5-0.2,1-0.4,1.5-0.6 c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.7-0.2s0.4-0.1,0.7-0.2c1.2-0.2,2.4-0.3,3.6-0.2c0.3,0,0.6,0,0.9,0.1 c0.2,0,0.4,0,0.6,0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0.1s0.2,0,0.3,0.1s0.2,0,0.3,0.1s0.2,0.1,0.3,0.1 s0.2,0.1,0.3,0.1l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2l0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2l0.2,0.1c0.1,0,0.1,0.1,0.2,0.1 s0.2,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.2,0.1l0.2,0.1 c0.3,0.2,0.6,0.4,0.8,0.6c0.1,0,0.1,0.1,0.2,0.2s0.1,0.1,0.2,0.2s0.1,0.1,0.2,0.2s0.1,0.1,0.2,0.2c0,0,0,0,0.1,0 c0.1,0,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4c1.3,1.4,2.4,3,3.1,4.8C88.7,49,87.5,54.6,84,58.4L84,58.4 L84,58.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18501",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    style: {
      fill: "#B1CDF7"
    },
    d: "M84,58.4c-1.8,2-4.2,3.3-6.8,4c-4.5,1.1-9.2-0.2-12.6-3.4 c-2.5-2.3-4-5.4-4.3-8.8c-0.4-3.9,1-7.8,3.7-10.7c3.2-3.4,7.8-4.9,12.4-4.1c0.8,0.1,1.5,0.3,2.2,0.6c1.8,0.6,3.4,1.6,4.8,3 C88.9,44.2,89.2,52.9,84,58.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    style: {
      fill: "#B9DEFD"
    },
    d: "M47.3,67.1c-10.9-7.4-10-17.6-10-17.6c4.3,2.4,8.5,8.1,9.8,12.5 c0.1,1.2,0.2,2.3,0.2,3C47.3,65.3,47.3,66.1,47.3,67.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    style: {
      fill: "#FFB27D"
    },
    d: "M56.9,63.4c0.5-0.1,1-0.4,1.3-0.8c0,0,0.3,0,0,0.7c0,0.1-0.1,0.2-0.2,0.3 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.5-0.1,1.1,0,1.7,0c0.1,0,0.1,0.3,0.1,0.4c0,0.2-0.1,0.5-0.2,0.7c-0.4,0.3-0.8,0.6-1.3,0.7 c-0.7,0.1-1.4,0-2-0.2l-0.7-0.3l0.2-1.2l0.2,0C56.3,63.8,56.6,63.4,56.9,63.4L56.9,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.5,45c0,0-9.3,1.8,2.7,15.2c1.9,2.2,12.3,4.9,12.3,4.9s1-0.9,0.5-1.6 c0,0-7.1-5.2-8.7-6c-0.7-0.4-2.8-8.3-3.9-10.2C42.7,46.2,41.7,45.4,40.5,45z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    style: {
      fill: "#FFB27D"
    },
    d: "M58.3,50c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.5,0.3-0.9,0.6-1.3c0.1-0.1,0.3,0,0.3,0.3 c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.4-0.2,0.8-0.2,1.2C59.1,50.3,58.3,50,58.3,50L58.3,50z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    style: {
      fill: "#2E9BF9"
    },
    d: "M109.9,132.2l1.2,0.5c0,0,5.4-7.5,6.1-14.2c0.1-1.1,0.1-2.3-0.2-3.4 c0,0,0.1-0.3,0.2-0.8c0-0.2,0.1-0.6,0.2-0.9c0.2-1,0.4-2.4,0.7-4c0.6-3.6,1.5-8.3,2.1-11.7l-0.3-0.1l-3.6-1.2l-0.8-2.4l-2.7-0.7 c0,0-0.6,1.2-1.2,6.8c-0.1,0.7-0.2,1.5-0.3,2.4c-0.2,3.3-0.2,6.6,0.3,9.8c0.1,1,0.3,2,0.5,3c0.1,1,0.2,2,0.1,3 C111.9,123.7,109.9,132.1,109.9,132.2L109.9,132.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    style: {
      fill: "#0B8AF8"
    },
    d: "M111.3,102.5l5.9,11.7c0-0.2,0.1-0.6,0.2-0.9c0.2-1,0.4-2.4,0.7-4 c0.6-3.6,1.5-8.3,2.1-11.7l-0.3-0.1l-3.6-1.2l-0.8-2.4l-2.7-0.7c0,0-0.6,1.2-1.2,6.8C111.5,100.9,111.4,101.7,111.3,102.5 L111.3,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    style: {
      fill: "#51ABFA"
    },
    d: "M113.2,95.3l0.1-1.2c2.3,0.6,8.4-1.7,8.4-1.7s2.2,1.9,1.9,6.6 c-0.1,2.3-0.4,11.9-0.7,14.8c-0.1,1-0.2,1.8-0.2,2.1l0,0c0,0.1,0,0.2,0.1,0.2c0.4,0.7,0.7,1.4,1,2.1c2.7,7.1-0.4,15.8-0.4,15.8 l-0.8-0.3c0,0-1.7-9.7-3.2-14c-0.2-0.6-0.4-1.1-0.7-1.6c-0.8-1.4-1.3-3-1.7-4.6c-1-4-1.8-8-2.3-12.1 C114.7,101.5,113.2,95.3,113.2,95.3L113.2,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    style: {
      fill: "#C62E45"
    },
    d: "M118.8,134.2h6.3c0.1-0.6,0-1.1-0.2-1.7c-0.3-0.7-0.8-1-0.7-1.9 c-0.5,0.6-1.2,0.8-2,0.8c-0.3,0.5-0.7,1-1.1,1.4C120.8,133.2,118.9,133.1,118.8,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    style: {
      fill: "#C62E45"
    },
    d: "M105.9,134.2h6.3c0.1-0.6,0.1-1.2-0.2-1.7c-0.3-0.4-0.3-1,0.1-1.4 c-0.3,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.7-0.1-0.9-0.3c-0.6,0.7-1.2,1.3-1.8,1.9C107.9,133.2,106.1,133.1,105.9,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    style: {
      fill: "#56130F"
    },
    d: "M111.9,64.7c0-0.2,0.1-2,2.9-2.1c0,0-1.4,0.2-1.6,0.8c0,0,0.9-0.8,1.7-0.5 s1.2,1.6,1.2,2s-0.4,1.8-0.9,2c-0.2,0-0.4,0-0.6,0c0.1,0.2,0.3,0.4,0.4,0.7c1.1,2.3,0,4.5-1,4.3c-0.6-0.2-0.8,0.9-0.8,0.9 l-5.9-4.8C107.4,67.9,109.6,63.5,111.9,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    style: {
      fill: "#FFB27D"
    },
    d: "M112.1,81.3c3.9,0.2,3.1-5.6,2.8-5.6c-0.5-0.2-1.3-1.5-1.8-3.5l-0.2,0.1l-2.8,1.3 c0,0,0.3,0.9,0.5,1.8c0.2,0.5,0.2,1,0.2,1.5c-0.2,0.1-0.4,0.2-0.4,0.2l0,0C110.4,77.1,111.1,81.2,112.1,81.3L112.1,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.5,84.5c-0.3-1.1-0.7-2.2-1-3.1c-0.5-1.4-1.1-2.9-1.8-4.3 c-0.8-1.7-4.5-1.6-4.5-1.6c-0.5,1.6-1.4,3.1-2.7,4.2c-1-0.6-1.8-2.8-1.8-2.8c-1.6,0.7-2.8,1.9-3.6,3.4c-1.1,2.6-2.4,6.4-3.4,7.5 c-0.6,0.4-1.2,0.8-1.8,1.1l0,0c0,0,0,0,0,0c0.2,0.5,0.4,0.9,0.7,1.3c0.3,0.5,0.7,0.9,1.3,1.2c0.4-0.2,1.1-0.5,1.4-0.7 c1.6-1.2,2.9-2.8,3.9-4.5l0.4,5.6l0.6,8.5c1,0.3,1.9,0.5,2.8,0.7c0.1-0.5,0.2-1.1,0.3-1.6c0.1,0.6,0.4,1.2,0.8,1.8 c8.1,1.3,11.8-2.2,11.8-2.2C125.1,94.2,124,89.3,122.5,84.5L122.5,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    style: {
      fill: "#B9DEFD"
    },
    d: "M102.5,90.3c0.3,0.5,0.7,0.9,1.3,1.2c0.4-0.2,1.1-0.5,1.4-0.7 c1.6-1.2,2.9-2.8,3.9-4.5c-0.1-0.6-3.3,2.6-3.8,3.2C105,90,103.4,90.3,102.5,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    style: {
      fill: "#ED985F"
    },
    d: "M110.1,73.6c0,0,0.3,0.9,0.5,1.8c1.7-0.5,2.2-2.2,2.3-3.1 C112.9,72.2,110.1,73.6,110.1,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    style: {
      fill: "#FFB27D"
    },
    d: "M109.8,74.5c0,0,4-0.9,3.3-3.4s-0.5-4.2-3.1-3.8s-2.8,1.5-2.8,2.4 S108.7,74.7,109.8,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    style: {
      fill: "#56130F"
    },
    d: "M107,68.4c0.4-0.9,0.9-0.8,1.2-0.7c1-1,2.6-1.1,3.7-0.3c0.4,1,1.2,1.9,2.2,2.4 c-0.7,0.5-1.5,0.7-2.4,0.6c-0.6,0-1.1-0.2-1.6-0.6c0.6,0.6,1.3,1.1,2.1,1.5c-2.2-0.4-3.7-3-3.8-3.2c-0.3,0.4-0.5,0.9-0.6,1.4 c0,0.7,0.2,2-0.2,2C107.7,71.5,106.4,69.8,107,68.4L107,68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    style: {
      fill: "#B9DEFD"
    },
    d: "M114.4,75.1c0,0,0.7,0.1,0.8,0.5c0,0-0.9,3.5-2.7,4.2L114.4,75.1L114.4,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    style: {
      fill: "#B9DEFD"
    },
    d: "M112.5,79.7c0,0-1.5-2.7-1.7-3.2c0,0-0.7,0.3-0.7,0.7 C110.2,77.2,111.7,79.5,112.5,79.7L112.5,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    style: {
      fill: "#B9DEFD"
    },
    d: "M117.1,78.5c-0.1,0.2-6.1,9.8-6.2,11.7s2.5,0.8,2.6,0.6S117.1,78.5,117.1,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    style: {
      fill: "#B9DEFD"
    },
    d: "M109.5,92l0.6,8.5c8.6-2.5,9.1-20.7,9.1-20.7l-5.3,9.6L109.5,92L109.5,92 L109.5,92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    style: {
      fill: "#FFB27D"
    },
    d: "M105.6,92.8L106,94l1.1-0.2c0.2,0,0.3-0.1,0.3-0.1c0.5-0.1,1.2-0.2,1.8-0.4l0,0 c1.2-0.3,2.5-0.6,3.6-1l0.3-0.1c0.6-0.2,1.1-0.4,1.6-0.8c0.1,0,0.1-0.1,0.1-0.1c1.1-0.8-2.4-2.7-3-2.3c-0.2,0.1-0.3,0.2-0.5,0.3 c-1,0.7-2.2,1.4-3.2,2c-0.5,0.3-1,0.6-1.4,0.8C106,92.6,105.6,92.8,105.6,92.8L105.6,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    style: {
      fill: "#FFFFFF"
    },
    d: "M111.4,89.4c0,1.4,0.8,2.7,2.1,3.4c2.5-0.9,3.8-4.6,4.8-7.1 c0.1-0.3,0.3-0.7,0.4-1c0.4-1.2,0.8-2.4,1.1-3.6c0.1-0.6,0.2-1.1,0.2-1.7c0-0.2-2.9-2.2-3.2-1.4c-0.5,1.2-1.1,2.8-1.6,4.4 c-0.3,0.9-0.6,1.7-0.9,2.5c-0.2,0.5-0.3,0.9-0.5,1.3c-0.2,0.6-0.5,1.2-0.8,1.8c-0.3,0.4-0.7,0.8-1.2,1.1 C111.8,89.2,111.6,89.3,111.4,89.4L111.4,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9571",
    style: {
      fill: "#C62E45"
    },
    d: "M101.8,89C101.8,89,101.8,89,101.8,89L101.8,89C101.8,89,101.8,89,101.8,89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18506"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    x: 69.4,
    y: 87.9,
    style: {
      fill: "#2DAA6F"
    },
    width: 34.5,
    height: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    x: 70.7,
    y: 89,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.9,
    height: 44.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9572",
    style: {
      fill: "#2E9BF9"
    },
    d: "M80.6,87.9v1.6c0,0.9,0.7,1.6,1.6,1.6h8.4c0.9,0,1.6-0.7,1.6-1.6l0,0v-1.6H80.6 L80.6,87.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9573",
    style: {
      fill: "#0677DA"
    },
    d: "M75.1,101.5v5.6h5.6v-5.6H75.1z M80.4,106.8h-5.1v-5.1h5.1V106.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9574",
    style: {
      fill: "#2DAA6F"
    },
    d: "M78,106c-0.1,0-0.2-0.1-0.3-0.1l-1.7-2.1c-0.1-0.2-0.1-0.4,0.1-0.6 c0.2-0.1,0.4-0.1,0.6,0.1l1.4,1.7l2.5-4.1c0.1-0.2,0.3-0.2,0.5-0.1l0,0c0.2,0.1,0.2,0.3,0.1,0.5l0,0l-2.8,4.6 C78.3,105.9,78.2,106,78,106L78,106L78,106z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9575",
    style: {
      fill: "#0677DA"
    },
    d: "M75.1,110.2v5.6h5.6v-5.6H75.1z M80.4,115.5h-5.1v-5.1h5.1V115.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9576",
    style: {
      fill: "#2DAA6F"
    },
    d: "M78,114.6c-0.1,0-0.2-0.1-0.3-0.1l-1.7-2.1c-0.1-0.2-0.1-0.4,0.1-0.6 c0.2-0.1,0.4-0.1,0.6,0.1l0,0l1.4,1.7l2.5-4.1c0.1-0.2,0.3-0.2,0.5-0.1l0,0c0.2,0.1,0.2,0.3,0.1,0.5l0,0l-2.8,4.6 C78.3,114.6,78.2,114.6,78,114.6C78.1,114.6,78,114.6,78,114.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9577",
    style: {
      fill: "#0677DA"
    },
    d: "M75.1,118.8v5.6h5.6v-5.6H75.1z M80.4,124.1h-5.1V119h5.1V124.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9578",
    style: {
      fill: "#2DAA6F"
    },
    d: "M78,123.1c-0.1,0-0.2-0.1-0.3-0.1l-1.7-2.1c-0.1-0.2-0.1-0.4,0.1-0.6 c0.2-0.1,0.4-0.1,0.6,0.1L78,122l2.5-4.1c0.1-0.2,0.3-0.2,0.5-0.1l0,0c0.2,0.1,0.2,0.3,0.1,0.5l0,0l-2.8,4.6 C78.3,123,78.2,123.1,78,123.1L78,123.1L78,123.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18519",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18516"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721",
    x: 84.4,
    y: 102.8,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    x: 96.2,
    y: 102.8,
    style: {
      fill: "#0677DA"
    },
    width: 1.7,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    x: 84.4,
    y: 105.2,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    x: 95.4,
    y: 105.2,
    style: {
      fill: "#0677DA"
    },
    width: 2.5,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18518"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    x: 95.9,
    y: 104,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    x: 89.8,
    y: 104,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    x: 84.4,
    y: 104,
    style: {
      fill: "#0677DA"
    },
    width: 4.5,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18523",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18520"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    x: 84.4,
    y: 110.9,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    x: 96.2,
    y: 110.9,
    style: {
      fill: "#0677DA"
    },
    width: 1.7,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18521"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    x: 84.4,
    y: 113.4,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    x: 95.4,
    y: 113.4,
    style: {
      fill: "#0677DA"
    },
    width: 2.5,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18522"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    x: 95.9,
    y: 112.2,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    x: 89.8,
    y: 112.2,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    x: 84.4,
    y: 112.2,
    style: {
      fill: "#0677DA"
    },
    width: 4.5,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18527",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18524"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    x: 84.4,
    y: 119.5,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    x: 96.2,
    y: 119.5,
    style: {
      fill: "#0677DA"
    },
    width: 1.7,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18525"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    x: 84.4,
    y: 121.9,
    style: {
      fill: "#0677DA"
    },
    width: 7.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    x: 95.4,
    y: 121.9,
    style: {
      fill: "#0677DA"
    },
    width: 2.5,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18526"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    x: 95.9,
    y: 120.7,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    x: 89.8,
    y: 120.7,
    style: {
      fill: "#0677DA"
    },
    width: 2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    x: 84.4,
    y: 120.7,
    style: {
      fill: "#0677DA"
    },
    width: 4.5,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9579",
    style: {
      fill: "#0677DA"
    },
    d: "M76.4,95.2c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0,0.4-0.1,0.4-0.3s-0.1-0.3-0.5-0.4 c-0.5-0.2-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,1-0.8c0.2,0,0.5,0,0.7,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.6-0.1 c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.2,0.5,0.4c0.5,0.2,0.7,0.4,0.7,0.8c0,0.5-0.4,0.9-1.1,0.9c-0.3,0-0.5-0.1-0.8-0.2 L76.4,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9580",
    style: {
      fill: "#0677DA"
    },
    d: "M80.6,95.8c-0.2,0.1-0.5,0.1-0.7,0.1c-0.7,0.1-1.4-0.4-1.4-1.2 c0-0.1,0-0.1,0-0.2c0-0.8,0.6-1.4,1.3-1.5c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,0.7,0.1l-0.1,0.5c-0.2-0.1-0.3-0.1-0.5-0.1 c-0.5,0-0.8,0.3-0.9,0.8c0,0.1,0,0.1,0,0.1c-0.1,0.4,0.3,0.9,0.7,0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5-0.1L80.6,95.8 L80.6,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9581",
    style: {
      fill: "#0677DA"
    },
    d: "M81,93.2c0.3,0,0.6-0.1,0.8-0.1c0.3,0,0.6,0.1,0.9,0.2c0.2,0.1,0.3,0.4,0.2,0.6 c0,0.3-0.2,0.6-0.5,0.7l0,0c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.3,0.2,0.7,0.2,0.8h-0.6c-0.1-0.2-0.2-0.4-0.2-0.6 c-0.1-0.3-0.2-0.4-0.4-0.4h-0.2v1.1H81L81,93.2L81,93.2z M81.6,94.4h0.2c0.3,0,0.5-0.2,0.5-0.4s-0.2-0.4-0.5-0.4 c-0.1,0-0.2,0-0.3,0V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9582",
    style: {
      fill: "#0677DA"
    },
    d: "M85.1,94.7h-1v0.7h1.1v0.5h-1.8v-2.8h1.7v0.5H84v0.6h1L85.1,94.7L85.1,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9583",
    style: {
      fill: "#0677DA"
    },
    d: "M87.3,94.7h-1v0.7h1.1v0.5h-1.8v-2.8h1.7v0.5h-1.1v0.6h1L87.3,94.7L87.3,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9584",
    style: {
      fill: "#0677DA"
    },
    d: "M87.8,95.9v-2.8h0.7l0.6,1c0.2,0.3,0.3,0.6,0.4,0.9h0c0-0.4-0.1-0.8-0.1-1.2 v-0.8h0.6v2.8h-0.7l-0.6-1.1c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.4,0,0.8,0,1.2v0.8C88.4,95.9,87.8,95.9,87.8,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9585",
    style: {
      fill: "#0677DA"
    },
    d: "M91.3,93.1v2.8h-0.6v-2.8H91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9586",
    style: {
      fill: "#0677DA"
    },
    d: "M91.8,95.9v-2.8h0.7l0.6,1c0.2,0.3,0.3,0.6,0.4,0.9h0c0-0.4-0.1-0.8-0.1-1.2 v-0.8h0.6v2.8h-0.7l-0.6-1.1c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.4,0,0.8,0,1.2v0.8H91.8L91.8,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9587",
    style: {
      fill: "#0677DA"
    },
    d: "M96.9,95.8c-0.3,0.1-0.6,0.2-0.9,0.2c-0.4,0-0.8-0.1-1.1-0.4 c-0.3-0.3-0.4-0.6-0.4-1c0-0.8,0.6-1.4,1.4-1.4c0.1,0,0.1,0,0.2,0c0.3,0,0.5,0,0.8,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.6-0.1 c-0.5,0-0.9,0.3-0.9,0.8c0,0.1,0,0.1,0,0.1c0,0.5,0.3,0.9,0.8,0.9c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0v-0.6h-0.4v-0.5h1 L96.9,95.8L96.9,95.8z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9588",
    style: {
      fill: "#FFB27D"
    },
    d: "M101.5,92.9c0.6,0,1.2-0.1,1.8-0.2c0,0-1.5,0-1.2-0.5c0.6-0.1,1.1-0.1,1.7,0 c0.4,0.1,0.8,0.2,1.2,0.5c0.7-0.1,1.3-0.3,1.9-0.5l0.2,1.6c0,0-2,0.6-3,1c-1,0.2-2,0-2.8-0.6c-0.3-0.3-0.5-0.6-0.5-1 C100.8,92.9,101.2,92.9,101.5,92.9L101.5,92.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1742",
    style: {
      fill: "#0B8AF8"
    },
    d: "M54.6,112.9H17.4c-1.9,0-3.4-1.5-3.4-3.4l0,0c0-1.8,1.5-3.4,3.4-3.4h37.2 c1.8,0,3.4,1.5,3.4,3.4l0,0C58,111.4,56.5,112.9,54.6,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1743",
    style: {
      fill: "#96CDFC"
    },
    d: "M57.3,115.4H14.7c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h42.6 c1.6,0,2.9,1.3,2.9,2.9l0,0C60.2,114.1,58.9,115.4,57.3,115.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_293",
    style: {
      fill: "#003B60"
    },
    cx: 46.9,
    cy: 112.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_294",
    style: {
      fill: "#003B60"
    },
    cx: 25.1,
    cy: 112.5,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9589",
    style: {
      fill: "#96CDFC"
    },
    d: "M25.4,131.4l22.2-18.1c0.4-0.3,0.6-0.8,0.3-1.3l0,0c-0.3-0.4-0.8-0.6-1.3-0.3 c0,0,0,0,0,0l-22.2,18.1c-0.4,0.3-0.6,0.8-0.3,1.3l0,0C24.4,131.5,25,131.7,25.4,131.4C25.4,131.4,25.4,131.4,25.4,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9590",
    style: {
      fill: "#96CDFC"
    },
    d: "M46.5,131.4l-22.2-18.1c-0.4-0.3-0.6-0.8-0.3-1.3l0,0c0.3-0.4,0.9-0.6,1.3-0.3 c0,0,0,0,0,0l22.2,18.1c0.4,0.3,0.6,0.8,0.3,1.3l0,0C47.6,131.5,47,131.7,46.5,131.4C46.6,131.4,46.5,131.4,46.5,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1744",
    style: {
      fill: "#96CDFC"
    },
    d: "M50.7,132.4h-29c-0.7,0-1.3-0.6-1.3-1.3l0,0c0-0.7,0.6-1.3,1.3-1.3h29 c0.7,0,1.3,0.6,1.3,1.3l0,0C52,131.8,51.4,132.4,50.7,132.4L50.7,132.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18532"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_295",
    style: {
      fill: "#FFFFFF"
    },
    cx: 48.7,
    cy: 133.4,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_296",
    style: {
      fill: "#4BB7E7"
    },
    cx: 48.7,
    cy: 133.4,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18533"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    style: {
      fill: "#FFFFFF"
    },
    cx: 24,
    cy: 133.4,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    style: {
      fill: "#4BB7E7"
    },
    cx: 24,
    cy: 133.4,
    r: 1.4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreening);
export default __webpack_public_path__ + "static/media/Screening.88ce0a3fc4b53d6be20b68927751363e.svg";
export { ForwardRef as ReactComponent };